import { Heading } from './Heading';
import { Section as SectionComponent } from './styles';
export const Section = SectionComponent;
Section.Heading = Heading;